import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
})
export class AuthLogoutComponent implements OnInit, OnDestroy {
	constructor(private router: Router) {
		localStorage.clear();
		this.router.navigate(['/login']);
	}

	ngOnInit() {}

	ngOnDestroy() {}
}
